"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _reactAddonsPureRenderMixin = _interopRequireDefault(require("react-addons-pure-render-mixin"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _AlertTypes = require("../alert/AlertTypes");

var _UICloseButton = _interopRequireDefault(require("../button/UICloseButton"));

var UIAlert = _react.default.createClass({
  displayName: "UIAlert",
  mixins: [_reactAddonsPureRenderMixin.default],
  propTypes: {
    children: _react.PropTypes.node,
    closeable: _react.PropTypes.bool.isRequired,
    onClose: _react.PropTypes.func,
    titleText: _react.PropTypes.node,
    type: _react.PropTypes.oneOf(Object.keys(_AlertTypes.ALERT_TYPES)).isRequired,
    use: _react.PropTypes.oneOf(Object.keys(_AlertTypes.ALERT_USES)).isRequired
  },
  getDefaultProps: function getDefaultProps() {
    return {
      closeable: false,
      type: 'info',
      use: 'default'
    };
  },
  render: function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        closeable = _this$props.closeable,
        onClose = _this$props.onClose,
        titleText = _this$props.titleText,
        type = _this$props.type,
        use = _this$props.use,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["children", "className", "closeable", "onClose", "titleText", "type", "use"]);
    var computedClassName = (0, _classNames.default)('alert', 'private-alert', 'private-alert--page-wide', _AlertTypes.ALERT_TYPES[type], className, {
      'private-alert--dismissable alert-dismissable': closeable
    }, {
      'private-alert--inline': use === 'inline'
    });
    return _react.default.createElement("div", (0, _extends2.default)({}, rest, {
      "aria-atomic": "true",
      "aria-live": "assertive",
      className: computedClassName,
      role: "alert"
    }), _react.default.createElement("div", {
      className: "private-alert__inner"
    }, titleText ? _react.default.createElement("h2", {
      className: "is--heading-5 private-alert__title"
    }, titleText) : null, _react.default.createElement("div", {
      className: "private-alert__body has--vertical-spacing"
    }, children)), closeable ? _react.default.createElement(_UICloseButton.default, {
      "aria-hidden": true,
      className: "close private-alert__close",
      onClick: onClose,
      size: "medium"
    }) : null);
  }
});

var _default = UIAlert;
exports.default = _default;
module.exports = exports.default;